/* eslint-disable */
import { fabric } from 'fabric';
fabric.RectButton = fabric.util.createClass(fabric.Rect, {
  type: 'rectButton',
  initialize(options) {
    options || (options = {});
    this.callSuper('initialize', options);
    this.set('label', options.label || '');
  },
  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      label: this.get('label'),
      isTextable: this.get('isTextable') || true,
    });
  },
  _render(ctx) {
    this.callSuper('_render', ctx);
    ctx.font = '20px Helvetica';
    ctx.fillStyle = '#333';
    var txtwidth = ctx.measureText(this.label).width;
    var mes = ctx.measureText(this.label);
    console.log(ctx);
    ctx.fillText(this.label, -(this.width / 2 - this.width / 2) - txtwidth / 2, -this.height / 2 + this.height / 2 + 5);
  },
});
fabric.RectButton.fromObject = function (object, callback) {
  fabric.Object._fromObject('RectButton', object, callback);
};
export default fabric.RectButton;
